var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))]),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":_vm.id,"disabled":"","aria-label":_vm.label},domProps:{"value":_vm.value}})])}
var staticRenderFns = []

export { render, staticRenderFns }